import { UserProfileType } from 'models/User';
import moment from 'moment';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import cl from 'country-language';
import { CallApi } from "Utils/Request";
import { useContext } from 'react';
import { LanguageContext } from '../Utils/Translation/LanguageContext'; 

export const useIsAuthenticated = () => {
    const [isAuthenticated, setIsAuthenticated] = useState(null)

    const user: any = useSelector((state: RootState) => state.user)
    const now = moment().valueOf();

    useEffect(() => {
        if (user.IS_LOGGED_IN && user.EXPIRES_ON > now / 1000) {
            setIsAuthenticated(true)
        } else {
            setIsAuthenticated(false)
        }
    }, [user.IS_LOGGED_IN])


    return isAuthenticated;
}
export const useGetProfile = (): UserProfileType | null | undefined => {
    const user: any = useSelector((state: RootState) => state.user)
    return user.PROFILE
}
export const useUserRoles = (): { id: number, title: string }[] => {
    const user: any = useSelector((state: RootState) => state.user)
    return user.PROFILE?.roles || []
}
export const useUserRoleIds = (): number[] => {
    const user: any = useSelector((state: RootState) => state.user)
    return (user.PROFILE?.roles || []).map(r => r.id)
}
export const useGetUserQuestionnaire = () => {
    const [userQuestionnaire, setUserQuestionnaire] = useState(false)

    const user = useSelector((state: RootState) => state.user)
    useEffect(() => {
        setUserQuestionnaire(user.USER_QUESTIONNAIRE_DATA)
    }, [])


    return userQuestionnaire;
}
export const useLanguage = () => {
  return useContext(LanguageContext);
};